<template>
	<div>
		<div class="titlePs"></div>
		<div class="titleBox">
			<div class="nav">
				<div class="ConpName">
					<img src="../assets/images/logo.png" class="logPic" />
					<div class="nameText">
						<div class="text1">摩米贝尔<p class="phone-number">联系方式：15989897729</p>
						</div>
						<div class="text2">无人自助解决方案服务商</div>
					</div>
				</div>
				<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
					<el-menu-item index="/">首页</el-menu-item>
					<el-menu-item index="/scene">适用场景</el-menu-item>
					<el-menu-item index="/funs">功能介绍</el-menu-item>
					<!-- <el-menu-item index="/price">价格</el-menu-item> -->
					<el-menu-item index="/agent">合作伙伴</el-menu-item>
					<el-menu-item index="/job">人才招聘</el-menu-item>
					<el-menu-item index="/about">关于我们</el-menu-item>
				</el-menu>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "navBar",
		data() {
			return {}
		},
		props: {
			activeIndex: {
				type: String,
			}
		},
		methods: {
			handleSelect(key, keyPath) {
				if (key == '/') {
					this.$router.push("/")
				} else if (key == "/scene") {
					this.$router.push("/scene")
				} else if (key == "/funs") {
					this.$router.push("/funs")
				} else if (key == "/price") {
					this.$router.push("/price")
				} else if (key == "/sVip") {
					this.$router.push("/sVip")
				} else if (key == "/agent") {
					this.$router.push("/agent")
				} else if (key == "/job") {
					this.$router.push("/job") 
				} else if (key == "/about") {
					this.$router.push("/about")
				}
			}
		}, 
		mounted() {			
			//console.log(this.activeIndex, '0000')		
		}
	}
</script>

<style>
	.titlePs {
		height: 90px;
	}

	.nameText {
		font-size: 1.4rem;
		float: left;
		line-height: 3rem;
		text-align: left;
		color: #666;
	}

	.logPic {
		height: 6rem;
		width: 6rem;
		float: left;
		margin-right: 1rem;
	}

	.el-menu-demo {
		margin-top: 1rem !important;

	}

	.el-menu--horizontal>.el-menu-item.is-active {
		color: #ff6a00 !important;
		font-weight: bold !important;
	}

	.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: 2px solid #ff6a00 !important;
	}

	.titleBox {
		width: 100%;
		background-color: #fff;
		position: fixed;
		top: 0;
		z-index: 99;
	}

	@media screen and (min-width: 1200px) {
		.phone-number {
			font-size: 1rem;
			display: inline-block;
			margin-left: 2rem;
		}

		.nav {
			width: 1200px;
			margin: 0 auto;
			height: 70px;
			padding-top: 10px;
			padding-bottom: 10px;
		}

		.titleBox {
			box-shadow: 0px 2px 10px #ccc;
		}

		.text1 {
			color: #ff6a00;
			font-weight: bold;
			font-size: 2rem;

		}
	}

	@media screen and (max-width: 1200px) {
		.nav {
			width: 100%;
			margin: 0 auto;
			height: 4rem;
		}

		.text1 {
			color: #ff6a00;
			font-weight: bold;
			font-size: 2rem;
			line-height: 4rem;
			width: 100%;
			text-align: center;
		}

		.el-dropdown-menu__item {
			font-size: 2rem !important;
			line-height: 3rem !important;
		}
	}

	.ConpName {
		flex: 1;
		font-size: 4rem;
		line-height: 3rem;
		display: flex;
		align-items: center;
		text-align: center;
	}

	.nav {
		display: flex;
		background-color: #fff;


	}

	.el-menu.el-menu--horizontal {
		border-bottom: unset !important;
	}
</style>
